/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CheckRule } from './checkRule';
import { ProjectFile } from './projectFile';
import { User } from './user';

export interface CheckResult { 
    id?: string;
    checkDate?: Date;
    completed?: boolean;
    checkType?: CheckResult.CheckTypeEnum;
    score?: number;
    totalCheckedElements?: number;
    results?: string;
    executionDurationMs?: number;
    workflowInstanceId?: string;
    checkRules?: Array<CheckRule>;
    projectFiles?: Array<ProjectFile>;
    checker?: User;
    archived?: boolean;
    archivedBy?: User;
    archivedAt?: Date;
    projectId?: number;
}
export namespace CheckResult {
    export type CheckTypeEnum = 'IDS' | 'AI' | 'HYBRID' | 'MIXED' | 'LOI' | 'HOAI' | 'QUALITY' | 'CUSTOM' | 'CROSS';
    export const CheckTypeEnum = {
        IDS: 'IDS' as CheckTypeEnum,
        AI: 'AI' as CheckTypeEnum,
        HYBRID: 'HYBRID' as CheckTypeEnum,
        MIXED: 'MIXED' as CheckTypeEnum,
        LOI: 'LOI' as CheckTypeEnum,
        HOAI: 'HOAI' as CheckTypeEnum,
        QUALITY: 'QUALITY' as CheckTypeEnum,
        CUSTOM: 'CUSTOM' as CheckTypeEnum,
        CROSS: 'CROSS' as CheckTypeEnum
    };
}